import React from "react"

function IconAntenna({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="antenna"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-antenna"
      {...props}
    >
      <path
        d="M12.12 4.542a3.1 3.1 0 0 1 .5 6.16l.018.025.046.1 3.56 9.737a.655.655 0 0 1-1.186.547l-.044-.097-.464-1.27H9.587l-.463 1.27a.655.655 0 0 1-.737.418l-.103-.028a.655.655 0 0 1-.418-.737l.028-.103 3.56-9.736a.685.685 0 0 1 .073-.145 3.1 3.1 0 0 1 .593-6.141zm1.632 13.02h-3.366l-.32.873h4.005l-.319-.872zm-1.683-4.604-1.205 3.296h2.41l-1.205-3.296zm6.76-10.405c2.473 2.477 2.473 7.444 0 9.921a.6.6 0 1 1-.85-.848c2.006-2.008 2.006-6.217 0-8.225a.6.6 0 1 1 .85-.848zm-13.514 0a.6.6 0 0 1 .85.848c-2.007 2.008-2.007 6.217 0 8.225a.6.6 0 1 1-.85.848c-2.474-2.477-2.474-7.444 0-9.92zm11.868 1.2c1.834 1.832 1.837 5.76.004 7.595a.6.6 0 1 1-.849-.848c1.364-1.366 1.363-4.534-.003-5.898a.6.6 0 0 1 .848-.85zm-10.222 0a.6.6 0 1 1 .848.849C6.443 5.966 6.44 9.134 7.805 10.5a.6.6 0 1 1-.85.848c-1.831-1.835-1.83-5.763.006-7.595zm5.16 2.098a1.791 1.791 0 1 0 0 3.582 1.791 1.791 0 0 0 0-3.582z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconAntenna
